(function () {
  function openDrawer() {
    document.getElementById('CartDrawer').classList.add('is-open');
    document.querySelector('[data-cart-drawer-overlay]').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    var overlay = document.querySelector('[data-cart-drawer-overlay]');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function refreshCartDrawer(thenOpen) {
    fetch(window.location.href)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('CartDrawer');
        var oldDrawer = document.getElementById('CartDrawer');
        if (newDrawer && oldDrawer) {
          oldDrawer.replaceWith(newDrawer);
          if (thenOpen) openDrawer();
        }
        var newCount = doc.querySelectorAll('[data-cart-drawer-toggle] .count, .mobile-bottom-nav__item .count');
        var oldCount = document.querySelectorAll('[data-cart-drawer-toggle] .count, .mobile-bottom-nav__item .count');
        oldCount.forEach(function (el) { el.remove(); });
        newCount.forEach(function (el, i) {
          var toggle = document.querySelectorAll('[data-cart-drawer-toggle]')[i];
          if (toggle) toggle.appendChild(el.cloneNode(true));
        });
      })
      .catch(function () {});
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () { refreshCartDrawer(true); });
  }

  function changeCartLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { refreshCartDrawer(false); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-toggle]')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-overlay]')) {
      closeDrawer();
    }

    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      addToCart(addBtn.dataset.variantId, 1);
    }

    var stickyBtn = e.target.closest('[data-sticky-add-to-cart]');
    if (stickyBtn && !stickyBtn.disabled) {
      e.preventDefault();
      addToCart(stickyBtn.dataset.variantId, 1);
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeCartLine(removeBtn.dataset.key, 0);
    }

    var minusBtn = e.target.closest('[data-cart-qty-minus]');
    if (minusBtn) {
      var input = document.querySelector('[data-cart-qty-input][data-key="' + minusBtn.dataset.key + '"]');
      var val = Math.max(0, parseInt(input.value, 10) - 1);
      changeCartLine(minusBtn.dataset.key, val);
    }

    var plusBtn = e.target.closest('[data-cart-qty-plus]');
    if (plusBtn) {
      var input2 = document.querySelector('[data-cart-qty-input][data-key="' + plusBtn.dataset.key + '"]');
      var val2 = parseInt(input2.value, 10) + 1;
      changeCartLine(plusBtn.dataset.key, val2);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (input) {
      changeCartLine(input.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
    }
  });

  // Product form add-to-cart (AJAX, unless "buy_now" was clicked which needs a real submit)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var submitter = e.submitter;
    if (submitter && submitter.name === 'buy_now') return; // let it navigate to checkout
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function () { refreshCartDrawer(true); });
  });
})();
